import Cart from './Cart/Cart';
import CheckoutUnintegratedPayment from './Cart/payment/CheckoutUnintegratedPayment';
import OpenBillPicker from './OpenBillPicker/OpenBillPicker';
import CheckoutUnintegratedPaymentFavritGiftCard from './Cart/payment/CheckoutUnintegratedPaymentFavritGiftCard';
import CreateBill from './OpenBillPicker/CreateDigitalBillDialog/CreateBill';
import { useCheckout } from '../../../context/CheckoutContext';
import SetTableNumberDialog from './OpenBillPicker/SetTableNumberDialog/SetTableNumberDialog';
import type { PaymentMethodDto } from '../../../../generated-api';

interface Props {
  cartTotalPrice: number;
  handleInitiatePayment: (
    paymentMethod: PaymentMethodDto,
    dynamicFields?: Record<string, string> | undefined,
    tipAmount?: number
  ) => void;
}

const CheckoutSidebarContent = (props: Props) => {
  const { cartTotalPrice, handleInitiatePayment } = props;
  const {
    showSelectTable,
    setSidebarContent,
    showCreateTableDialog,
    showPaymentDialog,
    showSetTableNumber,
    selectedPaymentMethod,
  } = useCheckout();

  if (showSelectTable) {
    return <OpenBillPicker />;
  }

  if (showCreateTableDialog) {
    return <CreateBill />;
  }

  if (showSetTableNumber) {
    return <SetTableNumberDialog />;
  }

  if (
    showPaymentDialog &&
    selectedPaymentMethod &&
    selectedPaymentMethod.provider === 'UNINTEGRATED' &&
    (selectedPaymentMethod.paymentMethod === 'FAVRIT_GIFT_CARD' ||
      selectedPaymentMethod.paymentMethod === 'FAVRIT_GIFT_CARD_INTERNAL')
  ) {
    return (
      <CheckoutUnintegratedPaymentFavritGiftCard
        paymentMethod={selectedPaymentMethod}
        onSubmit={(dynamicFieldValues) => handleInitiatePayment(selectedPaymentMethod, dynamicFieldValues)}
        onNavigateBack={() => setSidebarContent('CART')}
        isOpen={showPaymentDialog}
      />
    );
  }

  if (showPaymentDialog && selectedPaymentMethod) {
    return (
      <CheckoutUnintegratedPayment
        cartTotalPrice={cartTotalPrice}
        paymentMethod={selectedPaymentMethod}
        onSubmit={(dynamicFieldValues, tipAmount) =>
          handleInitiatePayment(selectedPaymentMethod, dynamicFieldValues, tipAmount)
        }
        onNavigateBack={() => setSidebarContent('CART')}
        isOpen={showPaymentDialog}
      />
    );
  }

  return <Cart />;
};

export default CheckoutSidebarContent;
